var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#2c9ac8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0V0z",
    fill: "none",
    id: "Layer_3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logosandtypes_com"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.9 74.7c0 21.6 12.5 40.2 30.7 49.1L25.7 52.4c-3.1 6.9-4.8 14.3-4.8 22.3zM112.4 72c0-6.7-2.5-11.4-4.5-15-2.8-4.5-5.4-8.3-5.4-12.8 0-5 3.8-9.6 9.2-9.6h.7c-9.8-8.9-22.6-14.3-36.9-14.3-19.1 0-35.8 9.8-45.6 24.6h3.5c5.7 0 14.6-.7 14.6-.7 2.9-.1 3.4 4.1.3 4.5 0 0-2.9.3-6.3.6l19.8 59.2 11.9-35.8-8.5-23.3c-2.9-.1-5.7-.6-5.7-.6-2.9-.1-2.6-4.7.3-4.5 0 0 9 .7 14.4.7 5.7 0 14.6-.7 14.6-.7 2.9-.1 3.4 4.1.3 4.5 0 0-2.9.3-6.3.6l19.7 58.7 5.4-18.2c2.7-7.9 4.5-13.3 4.5-17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5 79.4L60.1 127c5 1.5 10.1 2.2 15.4 2.2 6.4 0 12.4-1.2 18.1-3.1-.1-.3-.3-.4-.4-.7l-16.7-46zM123.4 48.5c.3 1.7.4 3.6.4 5.7 0 5.5-1 11.8-4.1 19.5l-16.6 48.2c16.2-9.5 27.1-27.1 27.1-47.2-.1-9.4-2.5-18.5-6.8-26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5 11c-35.1 0-63.7 28.6-63.7 63.7s28.6 63.7 63.7 63.7 63.7-28.6 63.7-63.7S110.6 11 75.5 11zm0 124.3c-33.5 0-60.8-27.2-60.8-60.8S42 13.8 75.5 13.8s60.8 27.2 60.8 60.8-27.3 60.7-60.8 60.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogo);
export default __webpack_public_path__ + "static/media/Wordpress-logo.e1454b2ce87f1335ba3c17395f3e4922.svg";
export { ForwardRef as ReactComponent };